import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {PublicApiAccessService} from "../services/publicApiAccess.service";
import {PublicApiAccess} from "../models/publicApiAccess";

@Component({
    templateUrl: './publicApiAccessForm.component.html',
    styleUrls: ['./publicApiAccessForm.component.scss'],
    animations   : fuseAnimations
})

export class PublicApiAccessFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    dialogRef: any;
    availableServices: Service[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private _matSnackBar: MatSnackBar,
        private publicApiAccessService: PublicApiAccessService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Actions');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            accessKey: ['', Validators.required],
        });

        if (!this.isAddMode) {
            this.publicApiAccessService.getById(this.id)
                .pipe(first())
                .subscribe((x: PublicApiAccess) => {
                    this.f.name.setValue(x.name);
                    this.f.accessKey.setValue(x.accessKey);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createPublicApiAccess();
        } else {
            this.updatePublicApiAccess();
        }
    }

    private createPublicApiAccess() {
        this.publicApiAccessService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Public API access added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Public API access creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updatePublicApiAccess() {
        this.publicApiAccessService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this._matSnackBar.open('Public API access update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                });
    }
}
